import { FlowError } from './types';

export const flowErrorName = 'FlowError' as const;

export const getFlowError = (message: string): FlowError => Object.assign(new Error(message), { name: flowErrorName });
